// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__DvcSW","content":"styles_content__1-_w9"};